'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventDefaultEvent = preventDefaultEvent;
exports.isEmptyObject = isEmptyObject;
exports.isFunction = isFunction;
exports.getTransitionEvent = getTransitionEvent;
exports.getAnimationEvent = getAnimationEvent;
exports.sortBy = sortBy;
exports.guid = guid;
exports.chunk = chunk;
function preventDefaultEvent(e) {
  e.preventDefault();
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

function isFunction(func) {
  return typeof func === 'function';
}

function getTransitionEvent() {
  var t;
  var el = document.createElement('fakeelement');
  var transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd'
  };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

function getAnimationEvent() {
  var t;
  var el = document.createElement('fakeelement');
  var transitions = {
    Animation: 'animationend',
    OAnimation: 'animationend',
    MozAnimation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd'
  };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

function sortBy(property, sortOrder) {
  var initSortOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'asc';
  var sorter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (sorter && isFunction(sorter)) {
    var flag = sortOrder === initSortOrder ? 1 : -1;
    return function (a, b) {
      return sorter(a[property], b[property]) ? flag : -flag;
    };
  } else {
    var _flag = sortOrder === 'asc' ? 1 : -1;
    return function (a, b) {
      var aVal = a[property];
      var bVal = b[property];
      if (aVal > bVal) {
        return _flag;
      }
      if (aVal < bVal) {
        return -_flag;
      }
      return 0;
    };
  }
}

function guid() {
  return 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

function chunk(array, chunkSize) {
  var R = [];
  for (var i = 0; i < array.length; i += chunkSize) {
    R.push(array.slice(i, i + chunkSize));
  }return R;
}